<template>
<svg v-on="$listeners" v-bind="$attrs" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :style="{width: `${size}px`, height: `${size}px`}">
    <defs></defs>
    <g id="Star-/-Null" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M10,14.5648879 L6.42712462,16.4432596 C5.93828004,16.7002604 5.33365288,16.5123139 5.07665207,16.0234693 C4.974313,15.8288088 4.93899833,15.6058408 4.97617517,15.3890831 L5.65853365,11.4106279 L2.76801675,8.59307031 C2.37253317,8.2075691 2.36444087,7.57445583 2.74994208,7.17897225 C2.90345068,7.02148862 3.10459309,6.91900144 3.32223012,6.88737693 L7.31682623,6.30692814 L9.10326392,2.68721002 C9.34768622,2.19195636 9.94731205,1.98861736 10.4425657,2.23303965 C10.6397783,2.33036989 10.7994058,2.48999741 10.8967361,2.68721002 L12.6831738,6.30692814 L16.6777699,6.88737693 C17.2243147,6.96679455 17.6029962,7.4742374 17.5235786,8.02078226 C17.4919541,8.23841929 17.3894669,8.4395617 17.2319833,8.59307031 L14.3414664,11.4106279 L15.0238248,15.3890831 C15.1171858,15.9334196 14.751598,16.4503755 14.2072616,16.5437365 C13.9905039,16.5809134 13.7675359,16.5455987 13.5728754,16.4432596 L10,14.5648879 Z" id="Star" stroke="#CCCCCC"></path>
    </g>
</svg>
</template>

<script>
export default {
    name: 'AtomIconStar',

    props: {
        size: {
            default: 48
        },

        status: {
            type: Number,
            default: 1
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/packages/Icon/StarO3d.vue